﻿import { ApiCaller, FullfilledApiResponse } from 'apis/ApiCaller';
import { EarlyAccessRing } from 'apis/EarlyAccessRingApi';

export interface FeatureFlag {
	Changes?: FeatureFlagChange[];
	CreateDate: string;
	CurrentRingName: string;
	Description?: string;
	DisplayName?: string;
	EarlyAccessRing: EarlyAccessRing
	Id: number;
	Name: string;
	ReleaseNotes?: string;
}

export interface User{

	firstname: string;

	// id needs to be like this in c# but we need Id for react
	id: number;
	Id: number;
	lastname: string;
	LoginId: string;
	RingId: number;
	RingName: string;
	username: string;
}

interface FeatureFlagChange {
	Comment: string;
	Date: string;
	Description: string;
	DisplayName: string;
	EarlyAccessRing: EarlyAccessRing;
	FeatureFlagId: number;
	Id: number;
	ReleaseNotes: string;
	UserId: string;
	UserName: string;
}

/**
 * Represents an api handler for the FeatureFlagController.
 * */
export class FeatureFlagApi {

    /**The api caller to use for HTTP requests. */
    private static apiCaller = new ApiCaller('FeatureFlag');

    /**
		 * Get a feature flag, including it ring change history.
		 * @param id The id of the feature flag.
		 */
    public static Get(id: number) : Promise<FeatureFlag> {

		    return this.apiCaller.GET<FeatureFlag>('Get', { id });

    }

    /**
		 * Get all students
		 * @param id The id of the feature flag.
		 */
    public static GetAllInviteOnlyUsers() {

		    //User Id needs to be id but also Id at the same time for the table to work properly
		    return this.apiCaller.GET<User[]>('GetAllInviteOnlyUsers');

    }

    /**
		 * Get all feature flags.
		 * @param searchTerm A string to search for in the properties of the feature flag.
		 * */
    public static GetAll(searchTerm: string, ringIds: number[]) : Promise<FeatureFlag[]> {

		    return this.apiCaller.GET<FeatureFlag[]>('GetAll', { ringIds, searchTerm });

    }

    /**
		 * Create a feature flag.
		 * @param name The name of the feature flag.
		 * @param ringId The id of the ring the feature flag should be in.
		 * @param releaseNotes Release notes for the feature flag.
		 * @param description A description of the feature flag.
		 * @param displayName A user friendly display name for the feature flag.
		 * @param comment The comment provided by the user with any notes they wish to include with creation.
		 */
    public static Create(comment: string, name: string, ringId: number, releaseNotes?: string, description?: string, displayName?: string) : Promise<number> {

		    return this.apiCaller.POST<number>('Create', { name, comment, description, displayName, releaseNotes, ringId });

    }

    /**
		 * Update a feature flag.
		 * @param id The id of the feature flag.
		 * @param ringId The updated id of the ring the feature flag should be in.
		 * @param releaseNotes Release notes for the feature flag.
		 * @param description The updated description for the feature flag.
		 * @param displayName A user friendly display name for the feature flag.
		 * @param comment The comment provided by the user explaining the update.
		 */
    public static Update(comment: string, id: number, ringId: number, releaseNotes?: string, description?: string, displayName?: string) : Promise<void> {

		    return this.apiCaller.PUT<void>('Update', { id, comment, description, displayName, releaseNotes, ringId });

    }

    /**
		 * Delete a feature flag, including it ring change history.
		 * @param id The id of the feature flag.
		 */
    public static Delete(id: number){

		    return this.apiCaller.DELETE('Delete', { id });

    }

    /**
		 * Get all students
		 * @param id The id of the feature flag.
		 */
    public static SetFeatureFlagUsers(userIds: string[], ringId: number) {

		    return this.apiCaller.PUT<FullfilledApiResponse>('SetFeatureFlagUsers', { ringId, userIds });

    }

}